/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AgentJobTypeEnum = 'PUSH_INVENTORY' | 'PUSH_HEALTH' | 'PUSH_USAGE' | 'RECONFIGURE';

export const AgentJobTypeEnum = {

    PUSH_INVENTORY: 'PUSH_INVENTORY' as AgentJobTypeEnum,

    PUSH_HEALTH: 'PUSH_HEALTH' as AgentJobTypeEnum,

    PUSH_USAGE: 'PUSH_USAGE' as AgentJobTypeEnum,

    RECONFIGURE: 'RECONFIGURE' as AgentJobTypeEnum
};

